import { render, staticRenderFns } from "./PrimaryDashboard.vue?vue&type=template&id=181f3fe4&scoped=true"
import script from "./PrimaryDashboard.vue?vue&type=script&lang=js"
export * from "./PrimaryDashboard.vue?vue&type=script&lang=js"
import style0 from "./PrimaryDashboard.vue?vue&type=style&index=0&id=181f3fe4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f3fe4",
  null
  
)

export default component.exports